import { storeToRefs } from 'pinia'
import type { Workspace } from '@apiTypes'
import { useAuthStore } from '@/stores/auth'

export function isTenderEnabledForWorkspace(workspace?: Workspace | null): boolean {
  const currentWorkspace = workspace ?? useAuthStore().currentWorkspace

  return currentWorkspace?.packageData?.tenderEnabled ?? false
}

export function isContractMatchingEnabledForWorkspace(workspace?: Workspace | null): boolean {
  const currentWorkspace = workspace ?? useAuthStore().currentWorkspace

  return currentWorkspace?.packageData?.contractMatchingEnabled ?? false
}

export function isContractAccessEnabledForWorkspace(workspace?: Workspace | null): boolean {
  return isTenderEnabledForWorkspace(workspace) || isContractMatchingEnabledForWorkspace(workspace)
}

export function useModuleQuotas() {
  const { currentWorkspace } = storeToRefs(useAuthStore())

  const isTenderEnabled = computed(() => isTenderEnabledForWorkspace(currentWorkspace.value))
  const isContractAccessEnabled = computed(() => isContractAccessEnabledForWorkspace(currentWorkspace.value))

  return { isTenderEnabled, isContractAccessEnabled }
}
